var map = {
	"./DrLubhani/ChangeColor": [
		777,
		178
	],
	"./Ganga/ChangeColor": [
		779,
		184
	],
	"./Indus/ChangeColor": [
		781,
		197
	],
	"./Kabini/ChangeColor": [
		783,
		204
	],
	"./Kaveri/ChangeColor": [
		695,
		20
	],
	"./Luni/ChangeColor": [
		785,
		210
	],
	"./Narmada/ChangeColor": [
		787,
		213
	],
	"./Neyyar/ChangeColor": [
		789,
		220
	],
	"./Periyar/ChangeColor": [
		791,
		223
	],
	"./SAANVI/ChangeColor": [
		793,
		233
	],
	"./Sabarmathi/ChangeColor": [
		795,
		240
	],
	"./Sparsh/ChangeColor": [
		797,
		246
	],
	"./Sutlej/ChangeColor": [
		799,
		250
	],
	"./Yamuna/ChangeColor": [
		801,
		256
	],
	"./pamba/ChangeColor": [
		803,
		265
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2054;
module.exports = webpackAsyncContext;